(function(w, $){
	"use strict";
	
	$(function(){
		var $w = $(w),
			$heroMove = $('.rs-hero-move');
		
		$w.resize(function(){
			$('.rs-hero .rslides').css('padding-bottom', function(){
				return $w.height() - $(this).offset().top
			});
		}).resize();
		
		$w.scroll(function(){
			$heroMove.toggleClass('active', $(this).scrollTop() < 1);
		});
		
		$heroMove.on('click', function(){
			$('html, body').animate({ scrollTop: $w.height() / 2 });
		}).addClass('active');
		
		/*
		$w.on('resize', function(){
		
			$('.rs-hero .rslides').css({paddingBottom: 0}).height(function(){
				return $w.height() - $(this).offset().top;
			});
			
		}).trigger('resize');
		*/
	});
	
	$(function(){
		var $w = $(w);
		$w.on('resize', function(){
			$('.vertically-centre-columns').each(function(){
				var $columns = $(this).find('> .vc_column_container').height('auto'),
					heights = $columns.map(function(){
						return $(this).height();
					}).get(),
					maxHeight = Math.max.apply(null, heights);
				
				$columns.each(function(){
					var $col = $(this),
						offset = (maxHeight - $col.height()) / 2;
					
					if(offset > 0){
						$col.css('transform', 'translateY(' + offset + 'px)');
					}
				});
			});
		}).on('load', function(){
			$w.trigger('resize');
		});
		
	});
	
	// Calculator Popup
	$.fn.calculatorTrigger = function(){
		this.each(function(){
			var $this = $(this);
			
			if($this.prop('tagName').toLowerCase() !== 'a'){
				var $anchors = $this.find('a');
				$anchors.calculatorTrigger();
				return true;
			}
			
			$this.prop('href', '#bb-calculator-form');
			$this.fancybox({
				padding: 0,
				baseClass: 'bb-calculator-form-fb',
				onComplete: function(){
					
				}
			});
		});
		
		return this;
	};
	
	$(function(){
		$('.open-calculator-form').calculatorTrigger();
	});
	
})(window, jQuery);

(function($){
	"use strict";
	
	var BbVolumeCalc = function(el){
		this.init(el);
		return this;
	};
	
	BbVolumeCalc.prototype = {
		init: function(el){
			var _self = this;
			
			_self.$calc = $(el);
			_self.$form = _self.$calc.find('> .bbvc-form');
			_self.$volume = _self.$calc.find('.bbvc-volume');
			//this.addListeners();
			
			_self.$form.on('submit', function(e){
				e.preventDefault();

				var lengthVal   = _self.$calc.find('.bbvc-length').val(),
					lengthType  = _self.$calc.find('.bbvc-length-qtf').val(),
					length      = lengthVal * lengthType,
					
					widthVal    = _self.$calc.find('.bbvc-width').val(),
					widthType   = _self.$calc.find('.bbvc-width-qtf').val(),
					width       = widthVal * widthType,
					
					depthVal    = _self.$calc.find('.bbvc-depth').val(),
					depthType   = _self.$calc.find('.bbvc-depth-qtf').val(),
					depth       = depthVal * depthType,
					
					volumeType = _self.$calc.find('.bbvc-volume-qtf').val(),
					volume = ((length * depth * width) / Math.pow(volumeType, 3)).toFixed(4);
				
				_self.$calc.find('.bbvc-volume').val(volume);
				
			});
			
			BbVolumeCalc.calculators.push(_self);
		},
	};
	
	$.extend(BbVolumeCalc, {
		calculators: []
	});
	
	$.fn.bbVolumeCalculator = function(){
		return this.each(function(){
			new BbVolumeCalc(this);
		});
	};
	
	$(function(){
		$('.bb-vol-calculator').bbVolumeCalculator();
	});
})(jQuery);